import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const HomeContainer = styled(Box)`
  height: 100dvh;
  flex: 1;
  min-width: 0;
  display: flex;
`;
